/** @jsx jsx */
import { jsx } from "@emotion/core"
import { List } from "@cd2/components"
import { LabelInfo } from "../Components/LabelInfo"
import { IRecord } from "../types/schema"
import { HoverResourceLoader } from "./HoverResourceLoader"
import { useGlobalState } from "../Components/GlobalStateProvider"
import { buildRoute, eRoutes } from "../routes"

type IUser = IRecord<"skeem_users", "name" | "skeem_email"> & { customer?: IRecord<"customers"> }

interface IProps {
  id: string
  initialData?: IUser
  renderInlineLink?: "block" | "inline"
  noLink?: boolean
  inline?: boolean
  resourceName?: string
}

export function HoverUserLoader({
  id,
  initialData,
  renderInlineLink,
  noLink,
  inline,
  resourceName,
}: IProps) {
  const skeem = window.skeem
  const { currentUser } = useGlobalState()

  async function loadData() {
    const user = await skeem.fetchOne<IUser>({
      skeem_users: {
        attributes: ["skeem_email", "name", "customer", "userAccountType"],
        filter: { matches: { id } },
      },
    })
    return user
  }

  function getViewLink(user: { id: string; customer?: { id: string } }) {
    if ((currentUser.isAdmin || currentUser.isSuperAdmin) && user.customer) {
      return buildRoute(eRoutes["/customers/:id/contacts"], { id: user.customer?.id })
    }
    if (currentUser.canAccessSystemSettings) {
      return buildRoute(eRoutes["/system/users/:id"], { id: user.id })
    }
    if (currentUser.canEditBranchSettings) {
      return buildRoute(eRoutes["/manage-branch/internal-users/:id"], { id: user.id })
    }

    return undefined
  }

  return (
    <HoverResourceLoader
      reloadKey={id}
      loadData={loadData}
      initialData={initialData}
      renderInlineLink={renderInlineLink}
      viewLink={getViewLink}
      resourceName={resourceName ?? "User"}
      renderHoverContentTitle={record => record.name}
      renderHoverContent={record => (
        <div>
          <List>
            <LabelInfo labelWidth={80} label="Name" value={record.name} inline />
            <LabelInfo labelWidth={80} label="Email" value={record.skeem_email} inline />
          </List>
        </div>
      )}
      renderTarget={record => <span>{record.name}</span>}
      inline={inline}
      noLink={noLink}
    />
  )
}
